import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import '@/lib/res'; // sets window.RES before the custom element renders
import '@/lib/image-slot.js'; // registers the <image-slot> custom element
import { App } from '@/App';

// Apply persisted/system theme early so the admin (direct load) is themed too.
const savedTheme = localStorage.getItem('aria-theme');
document.documentElement.setAttribute(
  'data-theme',
  savedTheme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'),
);

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
